import { getValidationMessage } from '@gef-ui/localization/messages';
import allPass from "ramda/es/allPass";
import compose from "ramda/es/compose";
import is from "ramda/es/is";
import isEmpty from "ramda/es/isEmpty";
import map from "ramda/es/map";
import not from "ramda/es/not";
import toUpper from "ramda/es/toUpper";
import isObject from "ramda-extension/es/isObject";
import { VALID } from '../../constants';
const notEmptyString = allPass([
    is(String),
    compose(not, isEmpty)
]);
export default ((validation, { severity, args })=>({ field, ...otherParams })=>{
        const result = validation({
            field,
            ...otherParams
        });
        const { messageKey, metaInfo = [], messageArgs = {} } = isObject(result) ? result : {
            messageKey: result
        };
        const notEmptyMessage = notEmptyString(messageKey);
        return {
            severity,
            valid: notEmptyMessage ? toUpper(severity) : VALID,
            errorMessage: notEmptyMessage ? getValidationMessage(messageKey, {
                field,
                messageKey,
                ...args,
                ...messageArgs
            }) : undefined,
            metaInfo: map(({ messageKey, ...other })=>({
                    errorMessage: notEmptyString(messageKey) ? getValidationMessage(messageKey, {
                        field,
                        messageKey,
                        ...args,
                        ...messageArgs
                    }) : undefined,
                    ...other
                }), metaInfo)
        };
    });
